<app-widget-card
        icon="assets/icons/ic_device.svg"
        [title]="'Dashboard.RecentEvents' | i18next"
        [showAreaPlaceholder]="isBusy"
        minHeight="500px"
>
    <div *ngFor="let event of callEvents">
        <app-call-event
                [event]="event"
                [expandedEventId]="expandedEventId"
                (callEventClicked)="callEventClicked($event)"
        ></app-call-event>
    </div>
    <div class="show-more" *ngIf="hasMoreEvents" (click)="showMoreEvents()">
        <p>{{"Dashboard.ShowAllEvents" | i18next}}</p>
    </div>
</app-widget-card>

<dx-popup *ngIf="showEventPopup"
          class="popup"
          [width]="'65%'"
          [height]="'80%'"
          [showTitle]="true"
          [title]="'Dashboard.Events' | i18next"
          [dragEnabled]="false"
          [showCloseButton]="true"
          [(visible)]="showEventPopup">
    <dx-scroll-view id="events-scroll-view"
                    #popupScrollView
                    (onReachBottom)="onPopupScrollEnd($event)">
        <app-call-event-filters
                [devices]="eventDevices || []"
                (filtersChanged)="onFiltersChanged($event)">
        </app-call-event-filters>

        <ng-container *ngIf="popupCallEvents && popupCallEvents.length > 0; else noEventsFound">
            <ng-container *ngFor="let event of popupCallEvents">
                <app-call-event
                        [event]="event"
                        [expandedEventId]="expandedPopupEventId"
                        (callEventClicked)="popupCallEventClicked($event)"
                ></app-call-event>
            </ng-container>
        </ng-container>

        <ng-template #noEventsFound>
            <div *ngIf="!isEventPopupLoading" class="no-events-message">
                <p>{{ 'Dashboard.NoEventsFoundMessage' | i18next }}</p>
            </div>
        </ng-template>
    </dx-scroll-view>
</dx-popup>

<dx-load-panel
        shadingColor="rgba(0,0,0,0.1)"
        [(visible)]="isEventPopupLoading"
        [position]="{ of: '#events-scroll-view' }"
        [showIndicator]="true"
        [showPane]="true"
        [shading]="false"
>
</dx-load-panel>
